import { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import IconSvg from 'src/components/common/ui/IconSvg';
import MultiversPointsCard, { CardStatus } from './components/MultiversPointsCard';
import {
  multiversMainPrizesData,
  MultiversPointsCardData,
  multiversPointsCardData,
} from 'src/dummydata';
import MultiversClaimBtn from './components/MultiversClaimBtn';
import LeaderBoardCard from './components/LeaderboardCard';
import RewardCard from 'src/components/common/cards/RewardCard';
import { useAccount } from 'wagmi';
import { useHttp } from 'src/hooks';
import { toast } from 'react-toastify';
import { ethers } from 'ethers';
interface TopUser {
  walletAddress: string;
  totalPoints: number;
  rank: number;
}
export default function MultiverxDetail() {
  const { collectionId } = useParams();
  console.log(collectionId, 'this is the collectionId ');
  const navigate = useNavigate();
  const { address } = useAccount();
  const { sendRequest } = useHttp();

  const { state } = useLocation();
  const hasHistory = state?.from || document.referrer;
  const [activeTab, setActiveTab] = useState('all');
  const [activeLeaderBoardTab, setActiveLeaderBoardTab] = useState('users');
  const [updatedCards, setUpdatedCards] =
    useState<MultiversPointsCardData[]>(multiversPointsCardData);
  const [topUsers, setTopUsers] = useState<TopUser[]>([]);
  const [accessToken, setAccessToken] = useState('');

  const tabs: { value: string; label: string; count?: number }[] = [
    { value: 'all', label: 'All' },
    {
      value: 'to-do',
      label: 'To Do',
      count: multiversPointsCardData.filter(card => card.status === 'to-do').length,
    },
    {
      value: 'done',
      label: 'Done',
      count: multiversPointsCardData.filter(card => card.status === 'done').length,
    },
  ];

  const leaderBoardTabs: { value: string; label: string }[] = [
    { value: 'users', label: 'Users' },
    { value: 'namecoins', label: 'Namecoins' },
  ];

  const tasksStatus = [
    { slug: 'xportal-wallet-creation', isClaimed: false },
    { slug: 'active-wallet', isClaimed: false },
  ];

  const getCompletedChallenges = (address: string, collectionId: string) => {
    if (address && collectionId) {
      sendRequest(
        {
          url: `user/challenges/completed/${collectionId}/${address}`,
          method: 'GET',
        },
        (data: any) => {
          updateCardData(data.challengeData);
          setTopUsers(data.topUsers);
        },
      );
    }
  };
  const updateCardData = (completedChallenges: any[]) => {
    const updated = multiversPointsCardData.map(card => {
      const challenge = completedChallenges.find(challenge => challenge.slug === card.slug);
      if (challenge) {
        return {
          ...card,
          completed: challenge.completed,
          status: challenge.completed ? 'Done' : 'To Do',
          isClaimed: challenge.completed,
        };
      }
      return card;
    });

    setUpdatedCards(updated);
  };

  useEffect(() => {
    if (address && collectionId) {
      getCompletedChallenges(address, collectionId);
    }
  }, [address, collectionId]);
  const handleConnectDiscord = () => {
    if (address) {
      sendRequest(
        {
          url: `auth/discord/login/${address}`,
          method: 'GET',
        },
        (data: any) => {
          if (data?.url) {
            window.location.href = data.url;
          }
        },
      );
    }
    console.log('Connect Discord button clicked');
  };

  const handleConnectX = () => {
    if (address) {
      sendRequest(
        {
          url: `twitter/login/${address}`,
          method: 'GET',
        },
        (data: any) => {
          if (data) {
            window.location.href = data;
          }
        },
      );
    }
    console.log('Connect X button clicked');
    // Add your logic here
  };

  const handleShareReward = () => {
    console.log('Share Reward on Twitter button clicked');
    // Add your logic here
  };

  const handleMintKey = () => {
    if (address) {
      sendRequest(
        {
          url: `user/add-mint-points/${address}`,
          method: 'POST',
        },
        (data: any) => {
          console.log(data);
        },
      );
    }
  };

  const handleOpenBox = () => {
    if (address) {
      sendRequest(
        {
          url: `user/add-open-box-points/${address}`,
          method: 'POST',
        },
        (data: any) => {
          console.log(data);
        },
      );
    }
    console.log('Open Box button clicked');
    // Add your logic here
  };

  const handleFollowMultiversX = () => {
    if (address) {
      sendRequest(
        {
          url: `twitter/follow/${address}/follow-multiversx-on-x`,
        },
        (data: any) => {
          console.log(data);
        },
      );
    }
    // Add your logic here
  };

  const handleFollowLootyFi = () => {
    if (address) {
      sendRequest(
        {
          url: `twitter/follow/${address}/follow-looty-fi-on-x`,
        },
        (data: any) => {
          console.log(data);
        },
      );
    }
    console.log('Follow @Looty_fi on X button clicked');
    // Add your logic here
  };
  const handleFollowXPortalAPP = () => {
    if (address) {
      sendRequest(
        {
          url: `twitter/follow/${address}/follow-xportalapp-on-x`,
        },
        (data: any) => {
          console.log(data);
        },
      );
    }
    console.log('Follow @Looty_fi on X button clicked');
    // Add your logic here
  };

  const handleSubscribePodcast = () => {
    if (address) {
      sendRequest(
        {
          url: `youtube/login/${address}`,
          method: 'GET',
        },
        (data: any) => {
          if (data?.url) {
            window.location.href = data.url;
          }
        },
      );
    }
    console.log('Subscribe Full Shard Podcast button clicked');
    // Add your logic here
  };

  const handleJoinTelegram = () => {
    console.log("Join MultiversX's Telegram button clicked");
    if (address) {
      sendRequest(
        {
          url: `telegram/invite-link`,
          method: 'GET',
        },
        (data: any) => {
          if (data) {
            sendRequest(
              {
                url: `${data}`,
                method: 'GET',
                isExternal: true,
              },
              (data: any) => {
                if (data?.result) {
                  sendRequest(
                    {
                      url: `telegram/mark-joined/${address}`,
                      method: 'POST',
                    },
                    (data: any) => {
                      if (data?.result) {
                        window.location.href = data.result;
                      } else {
                        console.log('Failed to fetch the redirect URL');
                      }
                    },
                  );

                  window.location.href = data.result;
                } else {
                  console.log('Failed to fetch the redirect URL');
                }
              },
            );
          }
        },
      );
    }
  };

  const handleWatchVideo = () => {
    navigate('/video');
    console.log('Watch Content Video button clicked');
  };

  const handleEnter = async (slug: string) => {
    if (!address) {
      toast.error('Wallet not connected. Please connect your wallet.');
      return;
    }

    const jwtString = localStorage.getItem('jwt');

    if (!jwtString) {
      await signInHandler(slug);
    } else {
      handleCardClick(slug); // Proceed to the card-specific logic
    }
  };

  useEffect(() => {
    // Check if a token is already present on page load
    const jwtString = localStorage.getItem('jwt');
    if (jwtString) {
      console.log('jwtString', jwtString);
      const data = JSON.parse(jwtString);
      const token = data.token;

      sendRequest(
        {
          url: 'auth/verify-token',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          payload: JSON.stringify({ token }),
        },
        (responseData: any) => {
          if (responseData.success) {
            setAccessToken(responseData.token);
          } else {
            localStorage.removeItem('jwt');
          }
        },
      );
    }
  }, []);

  const signInHandler = async (slug: string) => {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = await provider.getSigner();
    const address = await signer.getAddress();

    // Request the nonce from the backend
    const nonce = await requestNonce(address);

    // Sign the exact nonce message
    if (nonce) {
      const signature = await signer.signMessage(nonce);

      // Verify the signature with the backend
      const response = await verifySignature(address, signature);
      if (response) {
        const { success, token, id } = response;
        // authToken = token;
        console.log('success, token, id', `${success}, ${token}, ${id}`);
        if (success) {
          localStorage.setItem('jwt', JSON.stringify({ token, id }));

          setAccessToken(token);
          handleCardClick(slug);
        } else {
          toast.error('Signature verification failed');
          return;
        }
      }
    }
  };

  const verifyToken = async (authToken: string): Promise<{ success: boolean } | null> => {
    let verificationResult: { success: boolean } | null = null;

    await new Promise<void>(resolve => {
      sendRequest(
        {
          url: `auth/verify-token`,
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          payload: JSON.stringify({ authToken }),
        },
        (data: any) => {
          console.log('verifyToken response', data);
          verificationResult = data;
          resolve();
        },
      );
    });

    return verificationResult;
  };

  const requestNonce = async (address: string): Promise<string | null> => {
    let nonce: string | null = null;

    await new Promise<void>(resolve => {
      sendRequest(
        {
          url: `auth/request-nonce`,
          method: 'POST',
          payload: JSON.stringify({ walletAddress: address }),
        },
        (data: any) => {
          console.log('requestNonce response', data);
          nonce = data.nonce;
          resolve();
        },
      );
    });

    return nonce;
  };

  const verifySignature = async (address: string, signature: string) => {
    let result: { success: boolean; token: string; id: string } | null = null;

    await new Promise<void>(resolve => {
      sendRequest(
        {
          url: `auth/verify-signature`,
          method: 'POST',
          payload: JSON.stringify({ walletAddress: address, signature }),
        },
        (data: any) => {
          console.log('verifySignature response', data);
          result = data; // Response ko local variable mein assign karna
          resolve(); // Promise ko resolve karna
        },
      );
    });

    return result;
  };

  const handleCardClick = (slug: string) => {
    switch (slug) {
      case 'xportal-wallet-creation':
        console.log('Handle xPortal Wallet Creation logic here');
        break;
      case 'active-wallet':
        console.log('Handle Active Wallet logic here');
        break;
      case 'follow-multiversx-on-x':
        handleFollowMultiversX();
        break;
      case 'follow-looty-fi-on-x':
        handleFollowLootyFi();
        break;
      case 'follow-xportalapp-on-x':
        handleFollowXPortalAPP();

        break;
      case 'join-multiversxs-telegram':
        handleJoinTelegram();
        break;
      case 'like-and-rt-twitter-posts':
        console.log('Handle Like & RT Twitter Posts logic here');
        break;
      case 'buy-egld':
        console.log('Handle Buy $EGLD logic here');
        break;
      case 'subscribe-full-shard-podcast':
        handleSubscribePodcast();
        break;
      case 'stake-egld':
        console.log('Handle Stake $EGLD logic here');
        break;
      case 'watch-content-video':
        handleWatchVideo();
        break;
      default:
        console.log('No action defined for this slug');
        break;
    }
  };

  return (
    <>
      {hasHistory && (
        <button className="flex items-center gap-1.5 mb-[15px]" onClick={() => navigate(-1)}>
          <IconSvg icon="arrowLeftM" className="text-grayscale-400" />
          <span className="text-sm text-grayscale-400">Go Back</span>
        </button>
      )}

      <section className="mb-[40px]">
        <div className="flex gap-[19px] items-center mb-6">
          <div
            className="w-[109px] h-[109px] rounded-md"
            style={{
              backgroundImage: 'url(/assets/images/multivers-icon.png)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          ></div>

          <div className="space-y-[12px]">
            <div className="flex gap-[13px] items-end">
              <h3 className="uppercase text-brand-primary-light">multiversx PRE-SEASON</h3>

              <div className="text-sm text-grayscale-200">EGLD</div>
            </div>

            <div className="flex gap-[9px] items-center">
              <IconSvg icon="webM" className="text-grayscale-400" />

              <IconSvg icon="twitterM" className="text-grayscale-400" />

              <IconSvg icon="discordM" className="text-grayscale-400" />

              <IconSvg icon="hyperspaceM" className="text-grayscale-400" />
            </div>
          </div>
        </div>

        <p className="mb-6 text-grayscale-300">
          Get ready to kick off the first wave of rewards on MultiversX! Season 1 is all about
          helping you dive into the MultiversX ecosystem—create your new wallet, join the community,
          and make your first $EGLD purchase to start earning rewards. By completing these simple
          actions, you&apos;ll be on track to unlock lootboxes filled with $EGLD and exclusive
          rewards. The more you participate, the higher you climb on our leaderboard, and the bigger
          the rewards! Start your journey now and get set for an exciting season of exploration,
          engagement, and earnings on MultiversX! 🏆
        </p>

        <div className="flex flex-wrap gap-4 mb-4">
          <button
            className="flex items-center gap-2 px-4 py-2 bg-grayscale-800 text-grayscale-100 rounded-md"
            onClick={handleConnectDiscord}
          >
            Connect Discord ✅
          </button>
          <button
            className="flex items-center gap-2 px-4 py-2 bg-grayscale-800 text-grayscale-100 rounded-md"
            onClick={handleConnectX}
          >
            Connect X ✅
          </button>
          <button
            className="flex items-center gap-2 px-4 py-2 bg-grayscale-800 text-grayscale-100 rounded-md"
            onClick={handleShareReward}
          >
            Share Reward on Twitter ❌
          </button>
          <button
            className="flex items-center gap-2 px-4 py-2 bg-grayscale-800 text-grayscale-100 rounded-md"
            onClick={handleMintKey}
          >
            Mint Key ✅
          </button>
          <button
            className="flex items-center gap-2 px-4 py-2 bg-grayscale-800 text-grayscale-100 rounded-md"
            onClick={handleOpenBox}
          >
            Open Box ✅
          </button>
          <button
            className="flex items-center gap-2 px-4 py-2 bg-grayscale-800 text-grayscale-100 rounded-md"
            onClick={handleFollowMultiversX}
          >
            Follow @MultiversX on X ✅
          </button>
          <button
            className="flex items-center gap-2 px-4 py-2 bg-grayscale-800 text-grayscale-100 rounded-md"
            onClick={handleFollowLootyFi}
          >
            Follow @Looty_fi on X ✅
          </button>
          <button
            className="flex items-center gap-2 px-4 py-2 bg-grayscale-800 text-grayscale-100 rounded-md"
            onClick={handleSubscribePodcast}
          >
            Subscribe Full Shard Podcast ✅
          </button>
          <button
            className="flex items-center gap-2 px-4 py-2 bg-grayscale-800 text-grayscale-100 rounded-md"
            onClick={handleJoinTelegram}
          >
            Join MultiversX s Telegram ✅
          </button>
          <button
            className="flex items-center gap-2 px-4 py-2 bg-grayscale-800 text-grayscale-100 rounded-md"
            onClick={handleWatchVideo}
          >
            Watch Content Video ✅
          </button>
        </div>

        <div className="flex gap-4">
          <div className="w-[336px] bg-grayscale-800 rounded-md p-4 space-y-[8px]">
            <div className="flex items-center justify-center w-[44px] h-[44px] bg-grayscale-900 rounded-sm">
              <IconSvg icon="dollarM" className="text-grayscale-400" />
            </div>

            <div className="text-grayscale-400">Total Value of Rewards</div>

            <div className="text-grayscale-100 text-[24px] font-bold">≈ $50,000.00</div>
          </div>

          <div className="w-[336px] bg-grayscale-800 rounded-md p-4 space-y-[8px]">
            <div className="flex items-center justify-center w-[44px] h-[44px] bg-grayscale-900 rounded-sm">
              <IconSvg icon="poolM" className="text-grayscale-400" />
            </div>

            <div className="text-grayscale-400">Total Rewards Pool</div>

            <div className="text-grayscale-100 text-[24px] font-bold">≈ $50,000.00</div>
          </div>

          <div className="w-[336px] bg-grayscale-800 rounded-md p-4 space-y-[8px]">
            <div className="flex items-center justify-center w-[44px] h-[44px] bg-grayscale-900 rounded-sm">
              <IconSvg icon="giftM" className="text-grayscale-400" />
            </div>

            <div className="text-grayscale-400">Total Rewards Pool</div>

            <div className="text-grayscale-100 text-[24px] font-bold">118</div>
          </div>

          <div className="w-[336px] bg-grayscale-800 rounded-md p-4 space-y-[8px]">
            <div className="flex items-center justify-center w-[44px] h-[44px] bg-grayscale-900 rounded-sm">
              <IconSvg icon="usersM" className="text-grayscale-400" />
            </div>

            <div className="text-grayscale-400">Users on Leaderboard</div>

            <div className="text-grayscale-100 text-[24px] font-bold">381,916</div>
          </div>
        </div>
      </section>

      <div className="border-t-2 border-grayscale-700 mb-[40px]"></div>

      <section className="mb-[40px]">
        <div className="space-y-[10px] mb-[32px]">
          <h3 className="text-brand-primary-light">Earn Points, Unlock Rewards!</h3>

          <p className="text-sm text-grayscale-200">
            Do easy tasks to climb the leaderboard and win exclusive lootbox rewards!
          </p>
        </div>

        <div className="flex items-center justify-between px-5 py-3 mb-10 rounded-md bg-grayscale-800">
          <div className="flex gap-2">
            {tabs.map(tab => (
              <div
                key={tab.value}
                onClick={() => setActiveTab(tab.value)}
                className={`px-4 py-2 rounded cursor-pointer select-none ${
                  activeTab === tab.value ? 'bg-grayscale-600' : ''
                }`}
              >
                <div
                  className={`text-sm font-semibold ${
                    activeTab === tab.value ? 'text-grayscale-200' : 'text-gray-300'
                  }`}
                >
                  {tab.label} {tab.count ? `(${tab.count})` : ''}
                </div>
              </div>
            ))}
          </div>

          <MultiversClaimBtn status="claimable" onClick={() => ''} />
        </div>

        <div className="grid gap-[18px] grid-cols-[repeat(auto-fit,minmax(372px,1fr))]">
          {updatedCards
            .filter(card => card.status === activeTab || activeTab === 'all')
            .map((card, index) => {
              // const taskStatus = tasksStatus.find(task => task.slug === card.slug);
              const taskStatus = card.status;
              // const isClaimed = taskStatus?.isClaimed || false;
              // const isClaimed = false;

              return (
                <MultiversPointsCard
                  key={card.slug}
                  status={card.status as CardStatus}
                  bgImage={card.bgImage}
                  phase={card.phase}
                  pointsToEarn={card.pointsToEarn}
                  title={card.title}
                  description={card.description}
                  slug={card.slug}
                  onEnter={handleEnter}
                  onClaim={() => console.log('onClaim')}
                  // onClaim={handleCardClick}
                  isClaimed={card?.isClaimed}
                />
              );
            })}
          <img src="/assets/images/tasks/blur.png" className="h-full" />
          <img src="/assets/images/tasks/blur.png" className="h-full" />
        </div>
      </section>

      <div className="border-t-2 border-grayscale-700 mb-[40px]"></div>

      <section className="mb-[40px]">
        <div className="space-y-[10px] mb-[32px]">
          <h3 className="text-brand-primary-light">Leaderboard</h3>

          <p className="text-sm text-grayscale-200">
            Compete, earn points, and secure your spot at the top for exclusive lootbox prizes!
          </p>
        </div>

        <div className="flex items-center justify-between px-5 py-3 mb-3 rounded-md bg-grayscale-800">
          <div className="flex gap-2">
            {leaderBoardTabs.map(tab => (
              <div
                key={tab.value}
                onClick={() => setActiveLeaderBoardTab(tab.value)}
                className={`px-4 py-2 rounded cursor-pointer select-none ${
                  activeLeaderBoardTab === tab.value ? 'bg-grayscale-600' : ''
                }`}
              >
                <div
                  className={`text-sm font-semibold ${
                    activeLeaderBoardTab === tab.value ? 'text-grayscale-200' : 'text-gray-300'
                  }`}
                >
                  {tab.label}
                </div>
              </div>
            ))}
          </div>

          <div className="relative">
            <input
              type="search"
              placeholder="Search"
              className="w-[309px] bg-grayscale-900 text-grayscale-200 placeholder:text-grayscale-600 pl-9 py-2 text-sm relative rounded-md pr-3"
            />

            <IconSvg
              icon="searchS"
              className="absolute inset-y-0 m-auto left-4 text-grayscale-300"
            />
          </div>
        </div>

        <div>
          <div className="grid mb-3 grid-cols-15">
            <div className="col-span-2 pl-5 text-sm text-grayscale-300">Place</div>
            <div className="col-span-11 pl-4 text-sm text-grayscale-300">User Wallet</div>
            <div className="col-span-2 pr-5 text-sm text-grayscale-300 text-end">Points</div>
          </div>

          {topUsers.map(user => (
            <LeaderBoardCard
              key={user.rank}
              place={user.rank}
              wallet={user.walletAddress}
              points={user.totalPoints}
            />
          ))}
        </div>
      </section>

      <div className="border-t-2 border-grayscale-700 mb-[40px]"></div>

      <section className="mb-[40px]">
        <div className="space-y-[10px] mb-[32px]">
          <h3 className="text-brand-primary-light">MAIN PRIZES</h3>

          <p className="text-sm text-grayscale-200">
            Top the season and open lootboxes filled with $EGLD and exclusive prizes!
          </p>
        </div>

        <div className="grid gap-[18px] grid-cols-[repeat(auto-fit,minmax(326px,1fr))]">
          {multiversMainPrizesData.map((card, index) => (
            <RewardCard
              key={index}
              name={card.name}
              estimatedValue={card.estimatedValue}
              rarity={card.rarity}
              image={card.image}
              size="medium"
            />
          ))}
        </div>
      </section>
    </>
  );
}
